<div role="dialog" aria-labelledby="dialogTitle" tabindex="-1">
  <div class="modal-header">
    <div [ngClass]="{'active':isStep2, inactive:isStep1}">
      <button type="button" value="Back" class="back" aria-label="Back" (click)="back()">
        <span class="icon-Previous" aria-hidden="true"></span>
      </button>
    </div>
    <h2 id="dialogTitle" class="modal-title module-title">{{"plan.title"|translate}}</h2>
    <button type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <form #createPlanForm>
        <div>
          <div id="step1-content" [ngClass]="{'active':isStep1, inactive:isStep2}">
            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-textbox #planName (wfmTextboxEvent)="setPlanName($event.target.value)" inputName="planName"
                  [wfmAutoComplete]="'off'"
                  (inputOnInput)="checkFormValidationStatus()" (inputOnBlur)="checkPlanNameExists($event)" [maxLength]="32"
                  inputId="planName" [required]="true" [textValue]="planModel.planName"
                  label='{{ getLabelByFieldName("planName") | async }}' hasFocus=true>
                </wfm-textbox>
              </div>
            </div>
            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #entityType selectName="entityType" selectId="entityType"
                  label="{{ getLabelByFieldName('entityType')|async}}" [items]="entityTypeList"
                  placeHolder="{{ getLabelByFieldName('entityType')|async}}" [disabled]="entityTypeDisabled"
                  (wfmSelectEvent)="updateEntityType($event)" [selectedItem]="planModel.entityType">

                </wfm-select>
              </div>
            </div>


            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #entity selectName="entity" selectId="entity" label="{{getEntityLabel()|async}}"
                  [items]="entityList" placeHolder="{{getEntityLabel()|async}}" [showLoading]="entityListLoading"
                  [disabled]="entityDisabled" (wfmSelectEvent)="updateEntity($event)" [selectedItem]="selectedEntity">

                </wfm-select>
              </div>
            </div>


            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #forecastSource selectName="forecastSource" selectId="forecastSource"
                  label="{{ getLabelByFieldName('forecastSource')|async}}" [items]="forecastSourceList"
                  placeHolder="{{ getLabelByFieldName('forecastSource')|async}}" [disabled]="forecastSourceDisabled"
                  (wfmSelectEvent)="updateForecastSource($event)" [selectedItem]="planModel.forecastSource">
                </wfm-select>
              </div>
            </div>


            <div class="row">
              <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
                <wfm-select #forecast selectName="forecast" selectId="forecast"
                  label="{{ getLabelByFieldName('forecastLabel')|async}}" [items]="forecastList"
                  placeHolder="{{ getLabelByFieldName('forecastLabel')|async}}" [showLoading]="forecastListLoading"
                  [disabled]="forecastDisabled" (wfmSelectEvent)="updateForecast($event)" [selectedItem]="selectedForecast">

                </wfm-select>
              </div>
            </div>
          </div>
          <div id="step2-content" [ngClass]="{'active':isStep2, inactive:isStep1}">
            <div>
              <div class="radio-wrapper">
                <div class="radio">
                    <input #musRadioRef type="radio" name="mus" id="mus" [value]="MUType.MUS" [(ngModel)]="selectedMUType" (ngModelChange)="radioChangeHandler($event)">
                    <label for="mus">
                      {{"radio.label.mus"|translate}}
                    </label>
                </div>
                <div class="radio">
                    <input type="radio" name="mus" id="muset" [value]="MUType.MUSET" [(ngModel)]="selectedMUType" (ngModelChange)="radioChangeHandler($event)">
                    <label for="muset">
                      {{"radio.label.muset"|translate}}
                    </label>
                </div>
              </div>
              <div class="row">
                <div class='col-10 form-group'>
                  <div *ngIf="selectedMUType === MUType.MUS; else muSetBlock">
                    <label class="text-uppercase input-label" id="muselect-label" for="muselect" data-testid="multi-muselect-label">
                      {{"radio." + selectedMUType|translate}}
                    <span class="text-danger"> *</span>
                    </label>
                    <div>
                      <p-multiselect placeholder=" " #muselect name="muselect" inputId="muselect" ariaLabelledBy="muselect-label muselect-value" [(ngModel)] = "planModel.mus"
                                    [options]="muItems"
                                    [showToggleAll]="false"
                                    [virtualScroll]="true"
                                    [virtualScrollItemSize]="30"
                                    [filter]="false"
                                    (onChange) = "updateSelectedMUs($event)"
                                    (onPanelHide) = "setMuSelectAriaControls()"
                                    [showHeader]="false"
                                    styleClass="bg-lightgrey fullrow"
                                    [title] = "getMUsTooltip()"
                                    panelStyleClass="bg-red">
                        <ng-template let-value pTemplate="selectedItems">
                          <!-- <div *ngIf='value && value.length > 3; else elseBlock'> -->
                          <div class="ui-multiselected-item-token">
                              <span *ngIf='value && value.length > 1; else elseBlock'>{{value.length}} {{"multiselect.text"|translate}}</span>
                              <span *ngIf='value && value.length == 1'>{{value[0].id}} {{value[0].name}}</span>
                          </div>
                          <span *ngIf="!value || value.length === 0" class="ui-multiselected-empty-token">{{"radio."+selectedMUType|translate}}</span>
                        </ng-template>
                      <ng-template let-muItem pTemplate="item">
                        <div title="{{muItem.label}}" class="ui-multiselect-item-custom
                                    {{muItem.value.preferred?'multiselect-bg-white':'multiselect-bg-gray'}}
                                    {{muItem.separator?'item-separator':''}}">
                          <!-- <div class="ui-chkbox ui-widget">
                            <div class="ui-chkbox-box ui-widget ui-corner-all ui-state-default"
                                 [ngClass]="{'ui-state-active': muItem.isSelected}">
                              <span class="ui-chkbox-icon ui-clickable" [ngClass]="{'pi pi-check': muItem.isSelected}"></span>
                            </div>
                          </div> -->
                          <div class="checkbox">
                            <!-- tabindex="-1" + aria-hidden: this checkbox is a visual affordance
                                 only. The ARIA listbox pattern exposes selection state through
                                 aria-selected on the parent <li role="option"> (managed by PrimeNG
                                 via aria-activedescendant on the combobox input). Without this the
                                 option is announced twice (once as the option "Benta, not selected"
                                 and again as the nested checkbox "Benta, checkbox, not checked, to
                                 check press spacebar"), which is the verbose/repetitive output
                                 reported for the Scheduling Units combo box. Hiding the checkbox
                                 from the a11y tree leaves the option as the single announcer:
                                 "Benta, not selected/selected" (WCAG 4.1.2). Matches
                                 esp-multi-select-item. -->
                            <input type="checkbox" tabindex="-1" aria-hidden="true" [id]="'mu-item-' + muItem.value?.id" [checked]="muItem.isSelected"/>
                            <label [for]="'mu-item-' + muItem.value?.id" class="ui-multiselect-option-label">{{muItem.label}}</label>
                          </div>
                        </div>
                      </ng-template>

                    </p-multiselect>
                    <!-- Permanent listbox placeholder so the combobox aria-controls
                         always references an existing id, even when PrimeNG's panel
                         is closed (WCAG 4.1.2). Visually hidden, no focusable content. -->
                    <div id="muselect_list" role="listbox" class="sr-only" aria-hidden="true"></div>
                    <!-- Visually-hidden summary of the current selection.
                         Referenced by the combobox aria-labelledby so screen readers
                         announce the chosen value (e.g. "3 Collections") with the field
                         label when focus lands on the closed combobox (PrimeNG's readonly
                         combobox input otherwise carries no value, so NVDA/JAWS announce
                         it as blank). It is aria-hidden so it does NOT become an extra
                         browse-mode stop for the virtual cursor: aria-labelledby still
                         resolves hidden referenced text for the accessible name, while
                         selection-change announcements are made transiently via the CDK
                         LiveAnnouncer (see updateSelectedMUs) instead of a persistent
                         live region. Mirrors the visible selectedItems template. (ESP-18464) -->
                    <span id="muselect-value" aria-hidden="true"
                          class="sr-only">{{muSelectionSummary}}</span>
                    </div>
                  </div>
                  <ng-template #muSetBlock>
                    <wfm-select #muSet selectName="muSet" selectId="muSet" label="{{getLabelByFieldName('muSetLabel')|async}}"
                            [items]="muSets" placeHolder="{{getLabelByFieldName('muSetLabel')|async}}" [showLoading]="muSetLoading"
                            [disabled]="false" (wfmSelectEvent)="updateMUSet($event)" [selectedItem]="selectedMUSet">

                    </wfm-select>
                    <div id="muset-permissions-error" class="invalid-feedback" role="alert" aria-live="assertive" aria-atomic="true" [ngClass]="{'show-error': (planModel.muset && !isMuSetValid)}">
                      <span *ngIf="planModel.muset && !isMuSetValid" class="error-message">{{'validation.muset.permissions'|translate}}</span>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div>
                <label id="week-picker-label" class="text-uppercase input-label">
                  {{getLabelByFieldName('weekPickerLabel')|async}}
                  <span class="text-danger"> *</span>
                </label>
                <label class="input-label font-weight-normal sub-label">
                    {{'create.plan.select.unique.weeks' | translate }}
                </label>
              </div>
              <div role="group" aria-labelledby="week-picker-label" aria-describedby="duplicate-weeks-error">
              <div class="row">
                <div class='col-12 form-group'>
                  <!--<wfm-esp-week-picker #week1 name="week1"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 1)">
                </wfm-esp-week-picker>-->

                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    #week1
                    name="week1"
                    [ngModel]="weekRanges[1]"
                    (ngModelChange)="updateWeekFromRange($event,1)"
                    [startDOW]="startDOW"
                    role="group"
                    aria-label="Week 1 date range">
                  </sol-date-range-picker>
                </div>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    name="week2"
                    [ngModel]="weekRanges[2]"
                    (ngModelChange)="updateWeekFromRange($event,2)"
                    [startDOW]="startDOW"
                    role="group"
                    aria-label="Week 2 date range">
                  </sol-date-range-picker>
                  <!--<wfm-esp-week-picker #week2 name="week2"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 2)">
                  </wfm-esp-week-picker>-->

                    
                </div>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
<!--                  <wfm-esp-week-picker #week3 name="week3"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 3)">
                  </wfm-esp-week-picker>-->
                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    name="week3"
                    [ngModel]="weekRanges[3]"
                    (ngModelChange)="updateWeekFromRange($event,3)"
                    [startDOW]="startDOW"
                    role="group"
                    aria-label="Week 3 date range">
                  </sol-date-range-picker>
                </div>
              </div>
              <div class="row">
                <div class='col-12 form-group'>
                  <!--<wfm-esp-week-picker #week4 name="week4"
                                              [startDate]="getWeekStartDate()"
                                              [minDate]="minDate"
                                              [maxDate]="maxDate"
                                              (onDateChange)="updateWeek($event, 4)">
                  </wfm-esp-week-picker>-->
                  <sol-date-range-picker
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [prevNextButtons]="true"
                    arrowPosition="left"
                    [dateFormat]="localeDateFormat"
                    [allowTextInput]="false"
                    [type]="'week-selection'"
                    name="week4"
                    [ngModel]="weekRanges[4]"
                    (ngModelChange)="updateWeekFromRange($event,4)"
                    [startDOW]="startDOW"
                    role="group"
                    aria-label="Week 4 date range">
                  </sol-date-range-picker>
                </div>
              </div>
              </div>

              <div id="duplicate-weeks-error" class="invalid-feedback" role="alert" aria-live="assertive" aria-atomic="true" [ngClass]="{'show-error': hasDuplicateWeeks()}">
                  <span *ngIf="hasDuplicateWeeks()" class="error-message">{{'valication.duplicate.week'|translate}}</span>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button *ngIf="isStep1" buttonText="{{'plan.create.continue.btn'|translate}}"
                     id="create-plan-cont-btn"
                     [isPrimary]="true"
                     [isDisabled]="!enableContinue"
                     (clicked)="continue()"></breeze-button>

      <breeze-button *ngIf="isStep2" buttonText="{{'plan.create.btn'|translate}}"
                     id="create-plan-btn"
                     [isPrimary]="true"
                     [isDisabled]="!enableCreatePlan"
                     (clicked)="createPlan()"></breeze-button>
    </div>
  </div>
</div>
